import { typedObjectEntries } from "common/helpers/utils";

import { PROFILE_SEARCH_OPTIONS } from "../../../../../../../constants";
import Keywords from "../Keywords";
import SearchParamSelect from "./SearchParamSelect";

import type React from "react";

export default function DesktopLayout({
  totalCountComponent,
  resetSearchParamsButton,
}: {
  totalCountComponent: React.ReactNode;
  resetSearchParamsButton: React.ReactNode;
}) {
  return (
    <>
      <Keywords totalCountComponent={totalCountComponent} />

      <div className="flex justify-between gap-x-4">
        <article className="flex flex-wrap gap-2.5">
          {typedObjectEntries(PROFILE_SEARCH_OPTIONS).map(([key]) => (
            <SearchParamSelect key={key} optionsKey={key} />
          ))}
        </article>

        {resetSearchParamsButton}
      </div>
    </>
  );
}
